import { SharedHttpServiceProvider } from '@/shared/api/SharedHttpServiceProvider';
import type { IHttpClient } from '@/shared/api/clients/HttpClient';
import { BuergschaftService } from '@/buerge/api/services/buergschaft';
import { DokumentService } from '@/buerge/api/services/dokument';
import { Avalpartnerkonfigurator } from '@/buerge/api/services/avalpartnerkonfigurator';
import { PruefungenService } from '@/buerge/api/services/pruefungen.ts';
import { BuergschaftsauftragService } from '@/buerge/api/services/buergschaftsauftrag.ts';
import { PartnerService } from '@/buerge/api/services/partner.ts';
import { KreditvertragService } from '@/buerge/api/services/kreditvertrag.ts';

export class BuergeHttpServiceProvider extends SharedHttpServiceProvider {
  public readonly buergschaft: BuergschaftService;

  public readonly dokument: DokumentService;

  public readonly avalpartnerkonfigurator: Avalpartnerkonfigurator;

  public readonly pruefungen: PruefungenService;

  public readonly buergschaftsauftrag: BuergschaftsauftragService;

  public readonly partner: PartnerService;

  public readonly kreditvertrag: KreditvertragService;

  constructor(httpClient: IHttpClient) {
    super(httpClient);
    this.buergschaft = new BuergschaftService(httpClient);
    this.dokument = new DokumentService(httpClient);
    this.avalpartnerkonfigurator = new Avalpartnerkonfigurator(httpClient);
    this.pruefungen = new PruefungenService(httpClient);
    this.buergschaftsauftrag = new BuergschaftsauftragService(httpClient);
    this.partner = new PartnerService(httpClient);
    this.kreditvertrag = new KreditvertragService(httpClient);
  }
}
